import axios from 'axios'
export default {
    create(data) {
        var url = `/inventario/abrir`;
        return axios.post(url, data)
    },
    index(params = {}) {
        var url = `/inventario/`;

        return axios.get("/inventario/", { params });
    },
    get(inventarioUuid) {
        var url = `/inventario/${inventarioUuid}`;
        return axios.get(url)
    },
    getProductosCategoria(inventarioUuid, categoriaId) {
        var url = `/inventario/${inventarioUuid}/categoria/${categoriaId}/productos`;
        return axios.get(url)
    },
    cerrar(inventarioUuid) {
        var url = `/inventario/${inventarioUuid}/cerrar`;
        return axios.post(url)
    },
    actualizarProducto(inventarioUuid, productoId, cantidad) {
        var url = `/inventario/${inventarioUuid}/producto/${productoId}`;
        return axios.put(url, { cantidad: cantidad })
    },
    updateDetalle(inventarioUuid, detalleId, payload) {
        var url = `/inventario/${inventarioUuid}/detalle/${detalleId}`;
        return axios.put(url, payload)
    },
    getResumen(inventarioUuid) {
        console.log('inventarioUuid', inventarioUuid);

        var url = `/inventario/${inventarioUuid}/resumen`;
        console.log(axios.get(url));

        return axios.get(url)
    },
    // PDF para contar en papel, con los mismos números de línea que la pantalla.
    descargarHojaConteo(inventarioUuid) {
        return axios.get(`/inventario/${inventarioUuid}/hoja-conteo`, { responseType: 'blob' })
    },
    delete(inventarioUuid) {
        var url = `/inventario/${inventarioUuid}/eliminar`;
        return axios.delete(url)
    },

    // Acciones pendientes de control de stock de la sucursal (dashboard del
    // encargado). `sucursal` es el uuid: en el POS alcanza con el contexto de
    // la sesion, en contexto empresa hay que decir cual.
    getAlertas(params = {}) {
        return axios.get('/inventario/alertas', { params })
    },

    // Listado completo (paginado) de los productos afectados por una alerta.
    getProductosAlerta(tipo, params = {}) {
        return axios.get(`/inventario/alertas/${tipo}`, { params })
    },


}